var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"button-group"},[_c('span',[_vm._v("您可以选择：")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#1fb09f"},attrs:{"href":_vm.url + '/expenses/order-list/1',"target":"_blank"}},[_vm._v("返回订单列表")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#1fb09f"},attrs:{"href":"/","target":"_blank"}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/Payment/components/private-component/PaySuccessBtn.vue